import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { useModal } from "../../hooks/UseModal/useModal";

export const BaseIntroModal = (): JSX.Element => {
  const { modalConfig, modalIsOpen, closeModal } = useModal();

  const theme = useTheme();
  const { grey, secondary } = theme.palette;

  const handleClose = () => {
    closeModal();
  };

  const handleSubmit = () => {
    modalConfig.onSubmit();
    closeModal();
  };

  return (
    <Dialog
      open={modalIsOpen}
      aria-labelledby="responsive-dialog-title"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.65)",
      }}
      PaperProps={{
        sx: {
          borderRadius: "4px",
          boxShadow:
            "0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);",
          padding: "20px 24px",
        },
      }}
    >
      {modalConfig.imageSrc && (
        <img
          src={modalConfig.imageSrc}
          alt={modalConfig.imageAlt}
          style={modalConfig?.imageStyle}
        />
      )}
      <DialogTitle
        id="responsive-dialog-title"
        sx={{ textAlign: "center", padding: "16px 0px 24px" }}
      >
        {modalConfig.title}
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <DialogContentText>{modalConfig.contentText}</DialogContentText>
      </DialogContent>
      <Stack
        direction="row"
        justifyContent="flex-end"
        sx={{ paddingTop: "4px" }}
      >
        {modalConfig.cancelButtonLabel && (
          <Button
            autoFocus
            onClick={handleClose}
            sx={{ textDecoration: "underline" }}
          >
            {modalConfig.cancelButtonLabel}
          </Button>
        )}
        <Button color="secondary" variant="contained" onClick={handleSubmit}>
          {modalConfig.submitButtonLabel}
        </Button>
      </Stack>

      <Divider sx={{ border: `1px solid ${grey[400]}`, margin: "24px 0" }} />

      <Typography
        variant="caption"
        color="grey.800"
        sx={{
          letterSpacing: "0.4px",
          "& > a": {
            color: secondary.main,
          },
        }}
      >
        If you want to learn more about myTW,{" "}
        <a href="https://central.thoughtworks.net/home/mytw" target="_blank">
          read here
        </a>{" "}
        about the features and future!
      </Typography>
    </Dialog>
  );
};
